import Visualizations from './Visualizations';

export default Visualizations;
